import { FC } from 'react';
import classes from './style.module.scss';
import Text, { Ecolor } from '../text';
interface ILoaderProps {
  loadingmessage?: string;
}
const Loader: FC<ILoaderProps> = ({ loadingmessage = 'Loading ...' }) => {
  return (
    <>
      <div className={classes.overlay}>
        <div className={classes.loaderbox}>
          <Text color={Ecolor.deep}>{loadingmessage}</Text>
        </div>
      </div>
    </>
  );
};
export default Loader;
